// extracted by mini-css-extract-plugin
module.exports = {"wishlistButton":"WishlistButton_wishlistButton__pGmd5","wishlistIcon":"WishlistButton_wishlistIcon__RaVLY","isCampaignPage":"WishlistButton_isCampaignPage__jstIP"};